module.exports = __webpack_public_path__ + "img/treasure-home.3717df17.png";